<form>
  <div class="lv-modal-dialog">
    <div mat-dialog-title class="lv-dialog-header">
      <div class="lv-dialog-header-title">
        {{ titel }}
      </div>
      <div class="lv-dialog-icon-close">
        <mat-icon [svgIcon]="'Times'" (click)="closeDialog()"></mat-icon>
      </div>
    </div>
    <ng-container *ngIf="uiModul$ | async as uiModul">
      <div mat-dialog-content class="lv-dialog-content">
        <lv-uiartefakt-container [uiArtefakte]="uiModul.UIArtefakt"></lv-uiartefakt-container>
        <div class="lv-pflichtfeld-hinweis" *ngIf="isPflichtfeld$ | async" [innerHTML]="'INFOTEXT.PFLICHTFELD_ANGABE' | translate"></div>
      </div>
      <ng-container *ngIf="!showFooter">
        <div mat-dialog-actions class="lv-dialog-footer" align="end">
          <button mat-raised-button color="accent" (click)="abbrechenButtonClicked()">
            {{ 'MODAL_DIALOG.BUTTON_ABBRECHEN' | translate }}
          </button>
          <ng-container *ngIf="actionButton$ | async as actionButton">
            <ng-container *ngIf="!actionButton">
              <button mat-raised-button color="primary" (click)="weiterButtonClicked()">
                {{ 'MODAL_DIALOG.BUTTON_WEITER' | translate }}
              </button>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="actionButton$ | async as actionButton">
            <ng-container *ngIf="!!actionButton">
              <button mat-raised-button color="primary" (click)="actionButtonClicked(actionButton.ButtonAktionsTyp)">
                {{ actionButton.Text }}
              </button>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</form>
